import { render, staticRenderFns } from "./SpotsView.vue?vue&type=template&id=75fbf73a&lang=pug&"
import script from "./SpotsView.vue?vue&type=script&lang=ts&"
export * from "./SpotsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports